import React, { useEffect, useRef } from "react";
import { Text, Button, Icon } from "@bookingcom/bui-react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import { CloseIcon } from "@bookingcom/bui-assets-react/streamline";
import useTranslatedCountryNames from "../../../hooks/useTranslatedCountryNames.js";
import Frame from "../Frame/index.js";
import styles from "./POSMisMatch.module.css";
const POSMisMatch = (props) => {
    const { goToSearch, POSMismatch } = props;
    const i18n = useI18n();
    const focusElementRef = useRef(null);
    const { getCountryName, getCountryNameFrom, getCountryNameArticle, getCountryNameIn } = useTranslatedCountryNames();
    useEffect(() => {
        focusElementRef.current?.focus?.();
    }, []);
    if (!POSMismatch?.isPOSMismatch)
        return null;
    return (React.createElement(Frame, { p: 4, attributes: { role: "alertdialog" } },
        React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.headerCloseButton, onClick: goToSearch, ref: focusElementRef, tabIndex: 0, "aria-label": i18n.trans(t("close")), role: "button" },
                React.createElement(Icon, { svg: CloseIcon, size: "medium" })),
            React.createElement(Text, { variant: "headline_2", className: styles.headerText, attributes: { tabIndex: 0, role: "heading" } }, i18n.trans(t("flights_meta_different_pos_detected_header", {
                variables: {
                    country_name_from: getCountryNameFrom(POSMismatch.detectedPointOfSale),
                    name_article: getCountryNameArticle(POSMismatch.detectedPointOfSale),
                    country_name: getCountryName(POSMismatch.detectedPointOfSale)
                }
            })))),
        React.createElement(React.Fragment, null,
            React.createElement(Frame, null,
                React.createElement(Text, { variant: "body_1", attributes: { tabIndex: 0 } }, i18n.trans(t("flights_meta_different_pos_detected_sub_head", {
                    variables: {
                        country_name_in: getCountryNameIn(POSMismatch.detectedPointOfSale),
                        name_article: getCountryNameArticle(POSMismatch.detectedPointOfSale),
                        country_name: getCountryName(POSMismatch.detectedPointOfSale)
                    }
                })))),
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.footerSpacer }),
                React.createElement(Frame, { className: styles.footer },
                    React.createElement(Button, { variant: "primary", text: i18n.trans(t("flights_meta_different_pos_detected_cta")), size: "large", onClick: goToSearch, wide: true }))))));
};
export default POSMisMatch;
